import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

type SpinnerSize = 'sm' | 'md' | 'lg'

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
}

interface LoadingSpinnerProps {
  size?: SpinnerSize
  className?: string
  label?: string
  labelPosition?: 'right' | 'bottom'
}

function LoadingSpinner({
  size = 'sm',
  className,
  label,
  labelPosition = 'right',
}: LoadingSpinnerProps) {
  const spinner = <Loader2 className={cn('animate-spin', sizeClasses[size], className)} />

  if (!label) return spinner

  if (labelPosition === 'bottom') {
    return (
      <div className='flex flex-col items-center gap-2'>
        {spinner}
        <span className='text-sm text-muted-foreground'>{label}</span>
      </div>
    )
  }

  return (
    <span className='inline-flex items-center gap-2'>
      {spinner}
      <span className='text-sm text-muted-foreground'>{label}</span>
    </span>
  )
}

interface FullPageSpinnerProps {
  label?: string
  size?: SpinnerSize
  minHeight?: string
}

function FullPageSpinner({
  label = 'Carregando...',
  size = 'lg',
  minHeight = 'min-h-[50vh]',
}: FullPageSpinnerProps) {
  return (
    <div className={cn('flex items-center justify-center', minHeight)}>
      <LoadingSpinner size={size} label={label} labelPosition='bottom' className='text-primary' />
    </div>
  )
}

interface ButtonSpinnerProps {
  label?: string
}

function ButtonSpinner({ label }: ButtonSpinnerProps) {
  return (
    <>
      <Loader2 className='mr-2 h-4 w-4 animate-spin' />
      {label}
    </>
  )
}

interface CardSpinnerProps {
  label?: string
}

function CardSpinner({ label = 'Carregando...' }: CardSpinnerProps) {
  return (
    <div className='flex min-h-[200px] items-center justify-center'>
      <LoadingSpinner
        size='lg'
        label={label}
        labelPosition='bottom'
        className='text-muted-foreground'
      />
    </div>
  )
}

export { LoadingSpinner, FullPageSpinner, ButtonSpinner, CardSpinner }
export type { LoadingSpinnerProps, SpinnerSize }
